import React from 'react'

function SettingsBrand() {
  return (
    <div>SettingsBrand</div>
  )
}

export default SettingsBrand